/**
 * @file ServicePartsCatalogPage.jsx
 * @description SERVICE department — Parts Catalogue.
 *
 * The Dingli OEM parts manuals for the fleet: an assembly's exploded drawing
 * beside its parts table, and part-number search across every model.
 *
 * This file belongs to the SERVICE department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so a
 * change for SERVICE is made HERE and can never leak into another department's
 * screens. The shared engine underneath (PartsCatalogPage) and the backend stay
 * common — only the department-facing page is departmental. Route access is
 * department-gated in utils/permissions.js.
 */
import React from 'react';
import PartsCatalogPage from '../PartsCatalogPage';

const ServicePartsCatalogPage = () => (<PartsCatalogPage />);

export default ServicePartsCatalogPage;
